<template>
  <b-card style="padding:40px;">
    <h5><b>CREATE PURCHASE ORDER</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-size`"
            >Date <span class="danger-new"> *</span></label
          >
          <b-form-input
            v-model="input.date"
            id="input-horizontal"
            type="date"
            placeholder="DD/MM/YYYY"
            class="input-new"
            required
            @blur="getDate()"
            :min="minDate"
            :disabled="disableDate"
          ></b-form-input>

          <p v-if="error.date">
            <span class="danger-new">{{ this.error.date }}</span>
          </p>

          <p>
            <i
              ><b>Date format: DD/MM/YYYY</b><br />If date is 1st December 2020:
              01/12/2020. We recommend to use Mozilla Firefox & Google Chrome</i
            >
          </p>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <br />

    <b-row class="my-1">
      <b-col md="10">
        <label for="input-default"
          >Product Name<span class="danger-new"> *</span></label
        >
        <multiselect
          v-model="input.product_name"
          :options="product_name"
          :custom-label="nameWithSKU"
          placeholder="Please select"
          label="name"
          track-by="name"
        ></multiselect>
        <p v-if="error.product_name">
          <span class="danger-new">{{ this.error.product_name }}</span>
        </p>
      </b-col> </b-row
    ><br />

    <b-row>
      <b-col md="3">
        <label for="input-default"
          >Quantity<span class="danger-new"> *</span></label
        >
        <b-form-input
          v-model="input.qty"
          id="input-horizontal"
          class="input-new"
        ></b-form-input>
        <p v-if="error.qty">
          <span class="danger-new">{{ this.error.qty }}</span>
        </p>
      </b-col>

      <b-col md="3">
        <label for="input-default"
          >Quantity Type<span class="danger-new"> *</span></label
        >
        <b-form-select
          v-model="input.qtyType"
          :options="dropdown.qtyType"
          id="input-horizontal"
          required
          class="input-new"
        />
      </b-col>

      <b-col md="2" style="padding-top:27px;">
        <b-button variant="primary" size="m" @click="onClickAdd">+</b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button variant="danger" size="m" @click="onClickClear">x</b-button>
      </b-col>
    </b-row>
    <br />

    <TablePurchaseOrderCreate
      @delete="deleteItem($event)"
      :fields="fields"
      :items="items"
    />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickPreview">
          PREVIEW
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import TablePurchaseOrderCreate from "@/table/user/purchaseOrder/TablePurchaseOrderCreate";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  data() {
    return {
      form: {
        id: null,
        items: "",
        category: "",
        name: "",
        date: "",
        company: "",
        role: ""
      },
      items: [],
      selected: null,
      product_name: [],
      input: {
        product_name: "",
        date: "",
        qty: "",
        qtyType: "1"
      },
      error: {
        product_name: "",
        qty: ""
      },
      dropdown: {
        qtyType: [
          { text: "Pcs", value: "1" },
          { text: "Ctn", value: "2" }
        ]
      },
      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "qtyType",
          sortable: true
        },
        {
          label: "Action",
          key: "action",
          sortable: false
        }
      ],

      isSafari: false,
      disableDate: false,
      minDate: moment().format("YYYY-MM-DD")
    };
  },
  created() {
    this.getProduct();
    // this.showPO();

    this.isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && window["safari"].pushNotification)
      );

    let temp = localStorage.getItem("data_po");

    if (temp !== null) {
      let data = JSON.parse(temp);
      this.items = data.items;
    }

    let todayDate = moment().format("YYYY-MM-DD");
    let year = moment(todayDate).year();
    let month = moment(todayDate).month() + 1;

    if (this.isSafari) {
      if (month < 10) {
        month = "0" + month;
      }
    }

    let checkYear = moment(year + "-" + month + "-" + "05").format(
      "YYYY-MM-DD"
    );

    if (todayDate >= checkYear) {
      this.minDate = moment(year + "-" + month + "-" + "01").format(
        "YYYY-MM-DD"
      );
    } else {
      if (month == "01") {
        let newYear = year - 1;
        this.minDate = moment(newYear + "-" + "12" + "-" + "01").format(
          "YYYY-MM-DD"
        );
      } else {
        let newMonth = month - 1;
        this.minDate = moment(year + "-" + newMonth + "-" + "01").format(
          "YYYY-MM-DD"
        );
      }
    }

    if (this.$route.query.type !== undefined) {
      localStorage.removeItem("data_po");
    }
    if (this.$route.query.type === "update") {
      this.showPO();
      this.disableDate = true;
    }
  },
  methods: {
    onClickBack() {
      localStorage.removeItem("data_po");
      // this.$router.go(-1);
      if (
        this.$route.query.type === "new" ||
        (this.$route.query.type === "update" &&
          this.$route.query.from !== "update")
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: `purchase_order_user`
        });
      }
    },

    getDate() {
      let date = this.input.date;
      let curDate = moment(date, "DD/MM/YYYYY").format("YYYY-MM-DD");

      if (date.length > 10) {
        this.form.date = moment(new Date()).format("YYYY-MM-DD");
      }

      if (this.isSafari) {
        if (date.length !== 10) {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          // return;
        }
        if (date.slice(3, 4) !== "/" && date.slice(5, 6) !== "/") {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          // return;
        }

        if (moment(curDate).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
        }
      } else {
        if (moment(date).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
        }
      }
    },

    onClickSave() {
      let date = this.input.date;

      if (this.isSafari) {
        if (date.length !== 10) {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          return;
        }
        if (date.slice(3, 4) !== "/" && date.slice(5, 6) !== "/") {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          return;
        }

        date = moment(date, "DD/MM/YYYYY").format("YYYY-MM-DD");

        if (moment(date).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
          return;
        }
      } else {
        if (moment(date).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
          return;
        }
      }

      const form = {
        purchase_id: this.form.id ? this.form.id : null,
        date: date,
        product_id: this.input.product_name.sku,
        quantity: this.input.qty ? this.input.qty : null,
        quantity_type: this.input.qtyType ? this.input.qtyType : null,
        pro_stock_id: null
      };

      this.$store.dispatch("postPO", form).then(res => {
        this.items = [];
        this.form.id = res.data.data.purchase_id;
        res.data.data.pro_stock.forEach(element => {
          this.items.push({
            isActive: true,
            pro_stock_id: element.pro_stock_id,
            name: element.product.name,
            sku: element.product_id,
            quantity: element.quantity,
            qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn"
          });
        });
        this.input.product_name = "";
        this.input.qty = "";
      });
    },
    onClickAdd() {
      this.error.product_name = "";
      this.error.qty = "";
      this.error.date = "";

      this.checkForm();
      if (!this.error.product_name && !this.error.qty && !this.error.date) {
        this.onClickSave();
      }
    },
    getProduct() {
      this.product_name = [];
      this.$store.dispatch("getProduct").then(res => {
        res.data.data.forEach((element, index) => {
          this.product_name.push({
            sku: element.product_id,
            name: element.name,
            index: index
          });
        });
      });
    },
    nameWithSKU({ name, sku }) {
      return `${name} — [${sku}]`;
    },
    deleteItem(index) {
      this.$store
        .dispatch("deleteProMF", this.items[index].pro_stock_id)
        .then(res => {
          if (res.data.response.code === 1) {
            this.items.splice(index, 1);
          }
        });
    },
    showPO() {
      this.$store.dispatch("showPO", this.$route.query.id).then(res => {
        this.items = [];
        if (res.data.response.code === 100) {
          this.form.id = this.$route.query.id;

          this.form.date = moment(res.data.data.date).format("DD/MM/YYYY");

          if (this.isSafari) {
            this.input.date = moment(res.data.data.date).format("DD/MM/YYYY");
          } else {
            this.input.date = res.data.data.date;
          }

          res.data.data.pro_stock.forEach(element => {
            this.items.push({
              pro_stock_id: element.pro_stock_id,
              name: element.product.name,
              sku: element.product_id,
              quantity: element.quantity,
              qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn"
            });
          });
        }
      });
    },
    onClickPreview() {
      if (this.items.length < 1) {
        this.checkForm();
      }

      let date = this.input.date;

      if (this.isSafari) {
        if (date.length !== 10) {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          return;
        }
        if (date.slice(3, 4) !== "/" && date.slice(5, 6) !== "/") {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          return;
        }

        date = moment(date, "DD/MM/YYYYY").format("YYYY-MM-DD");
      }

      // this.form.id = this.$route.query.id;
      this.form.category = this.$route.query.cat;
      this.form.items = this.items;
      this.form.pro_cat = this.$route.query.pro_cat;
      this.form.date = date;

      localStorage.setItem("data_po", JSON.stringify(this.form));

      this.$router.push({ path: `previewPO` });
    },
    checkForm: function() {
      if (this.input.qty && this.input.product_name && this.input.date)
        return true;

      this.error.product_name = "";
      this.error.qty = "";
      this.error.date = "";

      if (!this.input.product_name)
        this.error.product_name = "Product Name required.";
      if (!this.input.qty) this.error.qty = "Quantity required.";
      if (!this.input.date) this.error.date = "Date required.";
      // e.preventDefault();
    },
    onClickClear() {
      this.input = {
        product_name: "",
        date: "",
        qty: "",
        qtyType: "1"
      };
    }
  },
  components: {
    TablePurchaseOrderCreate,
    Multiselect
  }
};
</script>
<style lang="css" scoped></style>
